import { createContext, useContext } from 'react';

export const EnhancedDataTableContext = createContext(null);

export const useEnhancedDataTableContext = () => useContext(EnhancedDataTableContext);
